// modules/PlanDisplay.js
import React        from 'react';
//import $            from 'jquery';
import PlanMapArea  from './PlanMapArea';
// import PlanStatusDots   from './PlanStatusDots';
import PlanLotsContainer  from './PlanLotsContainer';
// import PlanMasterOverlay  from "./PlanMasterOverlay";
//import Spacer       from '../../images/spacer.png';

var sources = require('../../config.json');

class planDisplay extends React.Component {
	constructor(props) {
		super(props);

		this.spacerImage = sources.spacerimage;

		this.state = {
			dimensions:{width:0, height:0},
			dotsize:34,
			elements:this.props.elements
		};

		this.eachElement        = this.eachElement.bind(this);
		this.adjustCoords    	= this.adjustCoords.bind(this);

		this.onImgLoad 			= this.onImgLoad.bind(this);
		this.resizeElements     = this.resizeElements.bind(this);
	}

	componentDidMount() {
		window.addEventListener("resize", this.resizeElements);
	}

	onImgLoad() {
		this.resizeElements();
	}

	resizeElements() {
		var img = document.getElementById('planImage');
		var imgheight = img.offsetHeight;
		var imgwidth = img.offsetWidth;
		var newelements = this.props.elements;
		var ratio = imgwidth/this.props.plan.plan_image_width;
		var dotsize = this.props.elements[0].sold_dot_size * ratio;

		for (var i = 0; i < newelements.length; i++) {
			if(newelements[i].coords) {
				newelements[i].coords = this.adjustCoords(newelements[i].ocoords, ratio);
			}
			if(newelements[i].sold_dot_position) {
				newelements[i].sold_dot_position = this.adjustCoords(newelements[i].osold_dot_position, ratio);
			}
		}

		let newState = Object.assign(this.state, {
			dimensions:{width:imgwidth,height:imgheight},
			dotsize:dotsize,
			elements:newelements
		});

		this.setState(newState);
	}

	adjustCoords(coords, ratio) {
		var coord = coords.split(",");
		for (var i = 0; i < coord.length; i++) {
			coord[i] *= ratio;
		}
		var newcoords = coord.join();
		return newcoords;
	}

	eachElement(element) {
		if(sources.activestatus.indexOf(element.status) !== -1) {
			return (
				<PlanMapArea key={element.id} id={element.id} messenger={this.props.messenger} data={element}></PlanMapArea>
			)
		} else {
			return null;
		}
	}

	render() {
		return (
			<div>
				<div className="landforsale-map_container landforsale-posrel">
					<map name="js-plan-map" id="js-plan-map">
						{this.state.elements.map(this.eachElement)}
					</map>
					<img className="planImage landforsale-plan_image" id="planImage" onLoad={this.onImgLoad} src={this.props.plan.plan_image} alt="" />
					{/*<div className="usageTip">Usage Tip: Use your mouse to interact with the {this.props.children}</div>*/}
					{/*<PlanStatusDots width={this.state.dimensions.width} height={this.state.dimensions.height} elements={this.state.elements} dotsize={this.state.dotsize} />*/}
					{/*<PlanMasterOverlay width={this.state.dimensions.width} height={this.state.dimensions.height} elements={this.state.elements} plantype={this.props.plantype}/>*/}
					<PlanLotsContainer width={this.state.dimensions.width} height={this.state.dimensions.height} elements={this.state.elements} messenger={this.props.messenger}/>
					<img src={this.spacerImage} style={{width: this.state.dimensions.width, height: this.state.dimensions.height}} alt="spacer" className="landforsale-map_spacer" useMap="#js-plan-map" />
				</div>
			</div>
		);
	}
}

export default planDisplay;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanDisplay.js
 **/